<template>
  <v-layout justify-center>
    <v-flex md8 xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <p class="body-1">{{ $t('labels.publishText') }}</p>
          <v-tooltip bottom>
            <v-btn @click="publishClick" color="primary" slot="activator">
              <v-icon small>fa-play fa-fw</v-icon>&nbsp;{{
                $t('buttons.publish')
              }}
            </v-btn>
            <span>{{ $t('tooltips.publish') }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  props: ['event'],

  methods: {
    publishClick() {
      this.$verify(
        this.$t('alerts.publishWarning') +
          '<br><br>' +
          this.$t('alerts.publishQuestion'),
        result => {
          if (result) {
            this.$emit('event-save', true, null, true, true)
          }
        }
      )
    },
  },
}
</script>
